export default "__VITE_ASSET__D1O6s1Xq__"